<script>
import loanApplication from '~/components/loanApplication'
export default {
  components: {
    thankYou: () => import( '~/whitelabels/vertaapankkeja/thankYou' )
  },
  extends: loanApplication
}
</script>
